import { useEffect } from 'react';

const useBodyScrollLock = (locked) => {
  useEffect(() => {
    if (locked) {
      document.body.classList.add('noscroll');
      // safari needs the class on the html element
      document.documentElement.classList.add('noscroll');
    } else {
      document.body.classList.remove('noscroll');
      document.documentElement.classList.remove('noscroll');
    }
    return () => {
      document.body.classList.remove('noscroll');
      document.documentElement.classList.remove('noscroll');
    };
  }, [locked]);
};

export default useBodyScrollLock;
